import React, { useState } from 'react';
import styles from 'components/burgerMenu/burgerMenu.module.css';
import { Menu } from 'components/menu/Menu';
import { AnimatedPart } from 'components/animatedPart/AnimatedPart';

export const BurgerMenu = ({ isMainColor }: { isMainColor: string }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);
    const burgerContainerStyles = isOpen
        ? `${styles.burgerContainerOpen}`
        : `${styles.burgerContainer}`;
    const burgerStyles = isOpen ? `${styles.cross}` : `${styles.burger}`;

    return (
        <div className={styles.container}>
            <div className={burgerContainerStyles}>
                <div className={styles.burgerBox} onClick={toggleMenu}>
                    {isOpen ? null : (
                        <h2
                            style={{
                                color: isMainColor,
                            }}
                        >
                            MENU
                        </h2>
                    )}
                    <div className={burgerStyles}>
                        <span
                            style={{
                                backgroundColor: isMainColor,
                            }}
                        ></span>
                        <span
                            style={{
                                backgroundColor: isMainColor,
                            }}
                        ></span>
                        <span
                            style={{
                                backgroundColor: isMainColor,
                            }}
                        ></span>
                    </div>
                </div>
            </div>

            {isOpen && (
                <div className={styles.fullScreenMenu}>
                    <div className={styles.menuBox}>
                        <AnimatedPart delay="0.6s">
                            <Menu isMobile={true} toggleMenu={toggleMenu} />
                        </AnimatedPart>
                    </div>
                </div>
            )}
        </div>
    );
};
